"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));

var _icons = require("../../icons");

var _layout = require("../../layout");

var _screenReaderOnly = require("../../screen-reader-only");

var _tooltip = require("../../tooltip");

var _utils = require("../../utils");

var _constants = require("../constants");

var _interfaces = require("../interfaces");

var _utils2 = require("../utils");

var _ToolbarFontColorItem = require("./ToolbarFontColorItem");

var _ToolbarHeadingItem = require("./ToolbarHeadingItem");

var _ToolbarHighlightItem = require("./ToolbarHighlightItem");

var _ToolbarItem = require("./ToolbarItem");

var _ToolbarLinkModal = require("./ToolbarLinkModal");

var _ToolbarTableItem = require("./ToolbarTableItem");

var _constants2 = require("./constants");

var _helperComponents = require("./helperComponents");

var _useFocusControl2 = require("./useFocusControl");

var _useLinkControl2 = require("./useLinkControl");

var _utils3 = require("./utils");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var WarningTooltip = (0, _tooltip.withTooltip)()(_icons.IconAlertCircleFill);
var Toolbar = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var ariaControls = _ref['aria-controls'],
      _ref$clipboardNotSupp = _ref.clipboardNotSupportedMessage,
      clipboardNotSupportedMessage = _ref$clipboardNotSupp === void 0 ? _constants.defaultProps.clipboardNotSupportedMessage : _ref$clipboardNotSupp,
      disabled = _ref.disabled,
      editorInstance = _ref.editorInstance,
      imageModalLocalization = _ref.imageModalLocalization,
      isFullScreen = _ref.isFullScreen,
      isSmallScreen = _ref.isSmallScreen,
      isToolbarFocusable = _ref.isToolbarFocusable,
      linkModalLocalization = _ref.linkModalLocalization,
      modalToMount = _ref.modalToMount,
      openImageModal = _ref.openImageModal,
      tablePopoverLocalization = _ref.tablePopoverLocalization,
      fontColorPopoverLocalization = _ref.fontColorPopoverLocalization,
      highlightPopoverLocalization = _ref.highlightPopoverLocalization,
      openTableModal = _ref.openTableModal,
      openTableEditModal = _ref.openTableEditModal,
      openKeyboardShortcuts = _ref.openKeyboardShortcuts,
      setIsFullScreen = _ref.setIsFullScreen,
      setModalToMount = _ref.setModalToMount,
      toolbarItems = _ref.toolbarItems;

  var _useFocusControl = (0, _useFocusControl2.useFocusControl)({
    onBlur: editorInstance ? editorInstance.focus : function () {
      return null;
    }
  }),
      focusPreviousElement = _useFocusControl.focusPreviousElement,
      keyHandler = _useFocusControl.keyHandler,
      storeRef = _useFocusControl.storeRef;

  var _useLinkControl = (0, _useLinkControl2.useLinkControl)(editorInstance, setModalToMount),
      closeLinkModal = _useLinkControl.closeLinkModal,
      isLinkModalOpen = _useLinkControl.isLinkModalOpen,
      openLinkModal = _useLinkControl.openLinkModal,
      toggleUrl = _useLinkControl.toggleUrl;

  var toolbarId = (0, _react.useMemo)(function () {
    return (0, _utils.getUniqueId)();
  }, []);
  (0, _react.useLayoutEffect)(function () {
    !disabled && isToolbarFocusable && focusPreviousElement();
  }, [disabled, isToolbarFocusable, focusPreviousElement]);
  var fontColorOptions = (0, _utils3.useFontColorOptions)(fontColorPopoverLocalization);
  var highlightOptions = (0, _utils3.useHighlightColorOptions)(highlightPopoverLocalization);

  if (editorInstance === null) {
    return null;
  } // Prevent editor blurring on click in toolbar area (expect buttons, etc).


  var preventBlurFocusedElements = function preventBlurFocusedElements(e) {
    return !isToolbarFocusable && e.preventDefault();
  };

  var renderToolbarControl = function renderToolbarControl(command) {
    var control = toolbarItems[command];

    if (!(0, _utils3.isToolbarControlVisible)(control)) {
      return null;
    }

    var isActive = editorInstance.isActive(command);
    var customFontColor = editorInstance.getAttributes('textStyle').color;
    var customHighlightColor = editorInstance.getAttributes('textStyle').backgroundColor;
    var isFontColorActive = editorInstance.isActive('textStyle', {
      class: _constants2.FONT_COLOR_DEFAULT_CLASS_NAME
    }) && customHighlightColor === null && customFontColor !== null;
    var isHighlightActive = editorInstance.isActive('textStyle') && customHighlightColor !== null;
    var controlCommands = editorInstance.commands[command];
    var commonProps = {
      'data-active': isActive,
      disabled: control.disabled || disabled,
      ref: storeRef
    };

    switch (command) {
      case _interfaces.Commands.blockquote:
        return (0, _core.jsx)(_ToolbarItem.ToolbarItem, (0, _extends2.default)({}, commonProps, {
          "aria-pressed": isActive,
          icon: _icons.IconBlockquote,
          key: command,
          onClick: controlCommands.toggle,
          tabIndex: -1,
          title: control.title
        }));

      case _interfaces.Commands.bold:
        return (0, _core.jsx)(_ToolbarItem.ToolbarItem, (0, _extends2.default)({}, commonProps, {
          "aria-pressed": isActive,
          icon: _icons.IconBold,
          key: command,
          onClick: controlCommands.toggle,
          tabIndex: -1,
          title: control.title
        }));

      case _interfaces.Commands.bulletList:
        return (0, _core.jsx)(_ToolbarItem.ToolbarItem, (0, _extends2.default)({}, commonProps, {
          "aria-pressed": isActive,
          icon: _icons.IconBulletedList,
          key: command,
          onClick: controlCommands.toggle,
          tabIndex: -1,
          title: control.title
        }));

      case _interfaces.Commands.clearFormat:
        return (0, _core.jsx)(_ToolbarItem.ToolbarItem, (0, _extends2.default)({}, commonProps, {
          icon: _icons.IconClearStyling,
          key: command,
          onClick: controlCommands.set,
          tabIndex: -1,
          title: control.title
        }));

      case _interfaces.Commands.fontColor:
        var fontColorAriaLabel = '';

        if (isFontColorActive) {
          var _fontColorPopoverLoca;

          fontColorAriaLabel = "".concat(control.title, ": ").concat((0, _utils3.getColorName)(customFontColor, fontColorOptions), " ").concat((_fontColorPopoverLoca = fontColorPopoverLocalization === null || fontColorPopoverLocalization === void 0 ? void 0 : fontColorPopoverLocalization.selectedText) !== null && _fontColorPopoverLoca !== void 0 ? _fontColorPopoverLoca : _constants2.toolbarFontColorPopoverDefaultProps.localization.selectedText);
        }

        return (0, _core.jsx)(_ToolbarFontColorItem.ToolbarFontColorItem, (0, _extends2.default)({}, commonProps, {
          "aria-pressed": isFontColorActive,
          "data-active": isFontColorActive,
          icon: _icons.IconTextColor,
          localization: fontColorPopoverLocalization,
          editorInstance: editorInstance,
          key: command,
          "aria-describedby": 'sroDialog',
          title: isFontColorActive ? fontColorAriaLabel : control.title
        }));

      case _interfaces.Commands.highlight:
        var highlightAriaLabel = '';

        if (isHighlightActive) {
          var _highlightPopoverLoca;

          highlightAriaLabel = "".concat(control.title, ": ").concat((0, _utils3.getColorName)(customHighlightColor, highlightOptions), " ").concat((_highlightPopoverLoca = highlightPopoverLocalization === null || highlightPopoverLocalization === void 0 ? void 0 : highlightPopoverLocalization.selectedText) !== null && _highlightPopoverLoca !== void 0 ? _highlightPopoverLoca : _constants2.toolbarHighlightPopoverDefaultProps.localization.selectedText);
        }

        return (0, _core.jsx)(_ToolbarHighlightItem.ToolbarHighlightItem, (0, _extends2.default)({}, commonProps, {
          "aria-describedby": 'sroDialog',
          "aria-pressed": isHighlightActive,
          "data-active": isHighlightActive,
          icon: _icons.IconTextHighlight,
          localization: highlightPopoverLocalization,
          editorInstance: editorInstance,
          key: command,
          title: isHighlightActive ? highlightAriaLabel : control.title
        }));

      case _interfaces.Commands.clipboard:
        if ((0, _typeof2.default)(control) !== 'object' || !Array.isArray(control.title) || !control.options) {
          return null;
        }

        var clipboardTitles = control.title;
        var isClipboardNotSupported = typeof ClipboardItem === 'undefined';

        var renderClipboardControl = function renderClipboardControl(key) {
          return control.options[key] && (0, _core.jsx)(_ToolbarItem.ToolbarItem, {
            disabled: control.disabled || isClipboardNotSupported || disabled,
            icon: key === 'copy' ? _icons.IconCopy : _icons.IconPaste,
            onClick: controlCommands[key],
            ref: storeRef,
            tabIndex: -1,
            title: clipboardTitles[key === 'copy' ? 0 : 1]
          });
        };

        return (0, _core.jsx)(_react.Fragment, {
          key: command
        }, renderClipboardControl('copy'), renderClipboardControl('paste'), isClipboardNotSupported && (0, _core.jsx)(WarningTooltip, {
          color: "primary70",
          ref: function ref(r) {
            return storeRef(r);
          },
          size: _icons.IconSize.ExtraSmall,
          tooltipText: clipboardNotSupportedMessage
        }));

      case _interfaces.Commands.fullScreen:
        return (0, _core.jsx)(_ToolbarItem.ToolbarItem, (0, _extends2.default)({}, commonProps, {
          "aria-pressed": isFullScreen,
          "data-active": isFullScreen,
          icon: isFullScreen ? _icons.IconUnfocus : _icons.IconFocus,
          key: command,
          onClick: function onClick() {
            return setIsFullScreen(function (prev) {
              return !prev;
            });
          },
          tabIndex: -1,
          title: control.title
        }));

      case _interfaces.Commands.heading:
        return (0, _core.jsx)(_ToolbarHeadingItem.ToolbarHeadingItem, (0, _extends2.default)({}, commonProps, {
          editorInstance: editorInstance,
          headingControl: control,
          key: command,
          paragraphControl: toolbarItems.paragraph
        }));

      case _interfaces.Commands.history:
        if (!control || !Array.isArray(control.title)) {
          return null;
        }

        var historyTitles = control.title;

        var renderHistoryControl = function renderHistoryControl(key) {
          return (0, _core.jsx)(_ToolbarItem.ToolbarItem, (0, _extends2.default)({}, commonProps, {
            icon: key === 'undo' ? _icons.IconUndo : _icons.IconRedo,
            onClick: controlCommands[key],
            tabIndex: -1,
            title: historyTitles[key === 'undo' ? 0 : 1]
          }));
        };

        return (0, _core.jsx)(_react.Fragment, {
          key: command
        }, renderHistoryControl('undo'), renderHistoryControl('redo'));

      case _interfaces.Commands.indent:
        if (!control || !Array.isArray(control.title)) {
          return null;
        }

        var indentTitles = control.title;

        var renderIndentControl = function renderIndentControl(key) {
          return (0, _core.jsx)(_ToolbarItem.ToolbarItem, (0, _extends2.default)({}, commonProps, {
            icon: key === 'set' ? _icons.IconIndentIncrease : _icons.IconIndentDecrease,
            onClick: controlCommands[key],
            tabIndex: -1,
            title: indentTitles[key === 'set' ? 0 : 1]
          }));
        };

        return (0, _core.jsx)(_react.Fragment, {
          key: command
        }, renderIndentControl('set'), renderIndentControl('unset'));

      case _interfaces.Commands.italic:
        return (0, _core.jsx)(_ToolbarItem.ToolbarItem, (0, _extends2.default)({}, commonProps, {
          "aria-pressed": isActive,
          icon: _icons.IconItalic,
          key: command,
          onClick: controlCommands.toggle,
          tabIndex: -1,
          title: control.title
        }));

      case _interfaces.Commands.keyboardShortcuts:
        var keyboardModalButtonId = "AccessibleToolbarShortcutButton".concat(toolbarId);
        return (0, _core.jsx)(_react.Fragment, {
          key: command
        }, (0, _core.jsx)(_ToolbarItem.ToolbarItem, (0, _extends2.default)({}, commonProps, {
          "aria-describedby": keyboardModalButtonId,
          icon: _icons.IconQuestionCircle,
          onClick: openKeyboardShortcuts,
          tabIndex: -1,
          title: control.title
        })), (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
          hidden: true,
          id: keyboardModalButtonId
        }, "has pop-up dialog"));

      case _interfaces.Commands.link:
      case _interfaces.Commands.image:
        var isLinkModal = command === _interfaces.Commands.link;
        var modalButtonId = "AccessibleToolbar".concat(command, "Button").concat(toolbarId);
        var localizationDefaultSource = isLinkModal ? _constants2.toolbarLinkModalDefaultProps : _constants2.toolbarImageModalDefaultProps;
        var localizationSource = isLinkModal ? linkModalLocalization : imageModalLocalization;
        var titleKey = "toolbarButton".concat(isActive ? 'Edit' : 'Add', "AltText");
        var title = (localizationSource && localizationSource.hasOwnProperty(titleKey) ? localizationSource : localizationDefaultSource.localization)[titleKey];
        return (0, _core.jsx)(_react.Fragment, {
          key: command
        }, (0, _core.jsx)(_ToolbarItem.ToolbarItem, (0, _extends2.default)({}, commonProps, {
          "aria-describedby": modalButtonId,
          icon: isLinkModal ? _icons.IconAnchorLink : _icons.IconImage,
          onClick: isLinkModal ? openLinkModal : openImageModal,
          tabIndex: -1,
          title: title
        })), (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
          hidden: true,
          id: modalButtonId
        }, "has pop-up dialog"));

      case _interfaces.Commands.orderedList:
        return (0, _core.jsx)(_ToolbarItem.ToolbarItem, (0, _extends2.default)({}, commonProps, {
          "aria-pressed": isActive,
          icon: _icons.IconNumberedList,
          key: command,
          onClick: controlCommands.toggle,
          tabIndex: -1,
          title: control.title
        }));

      case _interfaces.Commands.strike:
        return (0, _core.jsx)(_ToolbarItem.ToolbarItem, (0, _extends2.default)({}, commonProps, {
          "aria-pressed": isActive,
          icon: _icons.IconStrikethrough,
          key: command,
          onClick: controlCommands.toggle,
          tabIndex: -1,
          title: control.title
        }));

      case _interfaces.Commands.textAlign:
        if (!control || !Array.isArray(control.title)) {
          return null;
        }

        var textAlignTitles = control.title;
        var textAlignIcons = [_icons.IconLeftAlignment, _icons.IconCenterAlignment, _icons.IconRightAlignment];

        var renderTextAlignControl = function renderTextAlignControl(textAlign, index) {
          return (0, _core.jsx)(_ToolbarItem.ToolbarItem, (0, _extends2.default)({}, commonProps, {
            "aria-pressed": editorInstance.isActive({
              textAlign: textAlign
            }),
            "data-active": editorInstance.isActive({
              textAlign: textAlign
            }),
            icon: textAlignIcons[index],
            onClick: controlCommands[textAlign],
            tabIndex: -1,
            title: textAlignTitles[index]
          }));
        };

        return (0, _core.jsx)(_react.Fragment, {
          key: command
        }, renderTextAlignControl('left', 0), renderTextAlignControl('center', 1), renderTextAlignControl('right', 2));

      case _interfaces.Commands.underline:
        return (0, _core.jsx)(_ToolbarItem.ToolbarItem, (0, _extends2.default)({}, commonProps, {
          "aria-pressed": isActive,
          icon: _icons.IconUnderline,
          key: command,
          onClick: controlCommands.toggle,
          tabIndex: -1,
          title: control.title
        }));

      case _interfaces.Commands.table:
        var tableTitleKey = "toolbarButton".concat(isActive ? 'Edit' : 'Add', "AltText");
        var tableTitle = (tablePopoverLocalization && tablePopoverLocalization.hasOwnProperty(tableTitleKey) ? tablePopoverLocalization : _constants2.toolbarTablePopoverDefaultProps.localization)[tableTitleKey];
        return (0, _core.jsx)(_ToolbarTableItem.ToolbarTableItem, (0, _extends2.default)({}, commonProps, {
          editorInstance: editorInstance,
          title: tableTitle,
          localization: tablePopoverLocalization,
          openTableModal: openTableModal,
          openTableEditModal: openTableEditModal,
          icon: _icons.IconTable,
          key: command
        }));

      default:
        return null;
    }
  };

  var renderToolbarControlsBlock = function renderToolbarControlsBlock() {
    for (var _len = arguments.length, commands = new Array(_len), _key = 0; _key < _len; _key++) {
      commands[_key] = arguments[_key];
    }

    return (0, _utils3.isToolbarBlockVisible)(toolbarItems, commands) && (0, _core.jsx)(_helperComponents.ToolbarControlsBlock, {
      padding: isSmallScreen ? _constants2.TOOLBAR_CONTROLS_BLOCK_PADDING_MOBILE : _constants2.TOOLBAR_CONTROLS_BLOCK_PADDING_DESKTOP
    }, commands.map(renderToolbarControl));
  };

  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_focusTrapReact.default, {
    active: !isToolbarFocusable && modalToMount !== _interfaces.RTEModals.None,
    focusTrapOptions: {
      clickOutsideDeactivates: true,
      delayInitialFocus: false,
      escapeDeactivates: true,
      fallbackFocus: function fallbackFocus() {
        return (0, _core.jsx)("div", {
          tabIndex: -1
        });
      },
      initialFocus: false
    }
  }, (0, _core.jsx)(_helperComponents.ToolbarContainer, {
    "aria-controls": ariaControls,
    "aria-label": "Text Formatting",
    "aria-orientation": "horizontal",
    onKeyDown: keyHandler,
    onMouseDown: preventBlurFocusedElements,
    ref: ref,
    role: "toolbar"
  }, renderToolbarControlsBlock(_interfaces.Commands.heading), renderToolbarControlsBlock(_interfaces.Commands.bold, _interfaces.Commands.underline, _interfaces.Commands.italic, _interfaces.Commands.strike, _interfaces.Commands.clearFormat, _interfaces.Commands.fontColor, _interfaces.Commands.highlight), renderToolbarControlsBlock(_interfaces.Commands.bulletList, _interfaces.Commands.orderedList, _interfaces.Commands.blockquote), renderToolbarControlsBlock(_interfaces.Commands.image, _interfaces.Commands.link, _interfaces.Commands.table), renderToolbarControlsBlock(_interfaces.Commands.indent), renderToolbarControlsBlock(_interfaces.Commands.textAlign), renderToolbarControlsBlock(_interfaces.Commands.clipboard), renderToolbarControlsBlock(_interfaces.Commands.history), (0, _core.jsx)(_layout.Spacer, {
    margin: "0 0 0 auto"
  }), renderToolbarControlsBlock(_interfaces.Commands.keyboardShortcuts), renderToolbarControlsBlock(_interfaces.Commands.fullScreen))), modalToMount === _interfaces.RTEModals.Link && (0, _core.jsx)(_ToolbarLinkModal.ToolbarLinkModal, {
    close: closeLinkModal,
    defaultUrl: editorInstance && editorInstance.getAttributes('link') && editorInstance.getAttributes('link').href,
    isOpen: isLinkModalOpen,
    localization: linkModalLocalization,
    onClose: function onClose() {
      return setModalToMount(_interfaces.RTEModals.None);
    },
    onToggleUrl: toggleUrl,
    setReturnFocus: (0, _utils2.setEditorReturnFocus)(editorInstance)
  }));
});
var _default = Toolbar;
exports.default = _default;